function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.143 -386.648)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -107.143,
    cy: 636.648,
    r: 250,
    style: {
      fill: "#178181",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 636.648c0-50.16-14.77-96.866-40.2-136.01 0 0-14.262 20.833-11.582 34.225 2.678 13.393 18.413 14.416 16.797 24.24-1.617 9.824-13.224-2.811-27.512 23.08-14.287 25.892-7.14 61.616 13.393 64.29 20.534 2.672 49.104-9.825 49.104-9.825zM-41.489 395.359c29.099 7.898 56.088 20.922 79.939 38.038 0 0-28.988-4.781-39.97 5.037-10.98 9.821-26.995 33.04-39.97 0-12.972-33.037.001-43.075.001-43.075zM-295.113 471.823c45.819-52.212 113.043-85.175 187.97-85.175 0 0-16.96 10.27 15.182 27.68 32.143 17.412 17.41 25.446 10.714 30.803-6.696 5.358-18.31-10.714-25.896-21.426-7.587-10.716-40.168-27.232-65.17-18.301-25 8.93-46.425 15.527-42.856 23.836 3.567 8.306 46.425-7.759 62.496-6.87 16.071.89 10.714 10.71-4.462 22.318-15.178 11.608-16.967 25.893-.895 34.82 16.07 8.932 35.71 9.826 40.18 4.47 4.466-5.358-8.037-40.18 22.321-25.003 30.359 15.177 55.36 24.112 30.359 46.43-25.002 22.317-53.572 47.326-54.466 61.606-.895 14.282 8.932 25.899 3.574 26.787-5.357.889-10.274-5.801-13.844-10.715-3.567-4.912-20.088-6.695-28.124-3.573-8.036 3.122-23.216 15.177-14.732 26.785 8.485 11.61 20.083 6.247 31.693 11.605 11.609 5.357 22.434 25.747 20.211 30.355-2.222 4.607-12.118-1.226-20.21-16.962-8.095-15.737-23.277-5.357-33.959-8.036-10.682-2.677-18.718-4.463-29.433-23.214-10.715-18.749-32.898-23.996-41.962-34.82-25.966-31.006-24.109-54.464-29.465-65.178-5.357-10.716-19.226-28.222-19.226-28.222zM-83.036 640.22s26.786 2.674 40.178 14.284c13.393 11.609 15.182 16.076 35.716 20.538 20.534 4.461 29.465 16.066 16.071 38.39-13.392 22.321-37.504 58.037-49.108 68.752-11.604 10.716-25.89 19.644-31.248 37.5-5.357 17.855-7.146 28.563 4.463 35.711 0 0-6.246 15.18-20.533-4.463-14.288-19.645-2.68-42.856 0-56.25 2.677-13.391 9.819-53.566 5.355-63.392-4.46-9.824-25-16.076-30.358-36.608-5.358-20.533 4.018-60.492 29.464-54.462z",
    style: {
      fill: "#2aa846",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-283.92 459.873c97.632-97.634 255.92-97.632 353.552 0 97.633 97.63 97.633 255.92.001 353.551 0 0 113.426-149.99-47.16-310.577-160.589-160.588-306.393-42.974-306.393-42.974Z",
    style: {
      opacity: 0.36700056,
      fill: "#414141",
      fillOpacity: 1,
      enableBackground: "new"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.025716fb.svg";
export { ForwardRef as ReactComponent };